import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/queryKeys.ts
var t = e("csat", { eligibility: (e) => ["eligibility", e] });
//#endregion
export { t as csatQueryKeys };
